<template>
    <div class="order-infobox-modal">
        <header class="order-infobox-modal__header">
            <h3 class="order-infobox-modal__heading">
                Info
            </h3>
        </header>
        <div
            class="order-infobox-modal__content"
            v-html="content"
        />
    </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
    computed: {
        ...mapState({
            content: state => state.infoBoxModalContent,
        }),
    },
};
</script>



// WEBPACK FOOTER //
// InfoBox.vue?bf43c8aa